"use strict";

var _regeneratorRuntime = require("/home/travis/build/ulabox/boksa/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.postPaymentSuccess = exports.postDeliverySuccess = void 0;

var _effects = require("redux-saga/effects");

var _router = require("@modules/router");

var _cart = require("@modules/cart");

var _actions = require("./actions");

var postDeliverySuccess =
/*#__PURE__*/
_regeneratorRuntime.mark(function postDeliverySuccess(action) {
  return _regeneratorRuntime.wrap(function postDeliverySuccess$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.put)(_cart.cartActions.fetchCart());

        case 3:
          _context.next = 5;
          return (0, _effects.take)(_cart.cartActions.FETCH_CART_SUCCESS);

        case 5:
          _context.next = 7;
          return (0, _effects.put)(_router.routerActions.navigateTo(action.redirectRoute));

        case 7:
          _context.next = 12;
          break;

        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](0);
          console.error(_context.t0);

        case 12:
        case "end":
          return _context.stop();
      }
    }
  }, postDeliverySuccess, this, [[0, 9]]);
});

exports.postDeliverySuccess = postDeliverySuccess;

var postPaymentSuccess =
/*#__PURE__*/
_regeneratorRuntime.mark(function postPaymentSuccess(action) {
  return _regeneratorRuntime.wrap(function postPaymentSuccess$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.put)(_cart.cartActions.fetchCart());

        case 3:
          _context2.next = 5;
          return (0, _effects.take)(_cart.cartActions.FETCH_CART_SUCCESS);

        case 5:
          _context2.next = 7;
          return (0, _effects.put)(_router.routerActions.navigateTo(action.redirectRoute));

        case 7:
          _context2.next = 12;
          break;

        case 9:
          _context2.prev = 9;
          _context2.t0 = _context2["catch"](0);
          console.error(_context2.t0);

        case 12:
        case "end":
          return _context2.stop();
      }
    }
  }, postPaymentSuccess, this, [[0, 9]]);
});

exports.postPaymentSuccess = postPaymentSuccess;

var checkout =
/*#__PURE__*/
_regeneratorRuntime.mark(function checkout() {
  return _regeneratorRuntime.wrap(function checkout$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeLatest)(_actions.POST_DELIVERY_SUCCESS, postDeliverySuccess);

        case 2:
          _context3.next = 4;
          return (0, _effects.takeLatest)(_actions.POST_PAYMENT_SUCCESS, postPaymentSuccess);

        case 4:
        case "end":
          return _context3.stop();
      }
    }
  }, checkout, this);
});

var _default = checkout;
exports.default = _default;